// web/src/pages/Splash.tsx
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function Splash() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";

  // If the user already saw splash, bounce straight to landing (or next)
  useEffect(() => {
    const seen = localStorage.getItem("sg_seen_splash");
    if (seen === "1") navigate(next, { replace: true });
  }, [navigate, next]);

  const handleEnter = () => {
    localStorage.setItem("sg_seen_splash", "1");
    navigate(next, { replace: true });
  };

  return (
    <div className="relative min-h-screen overflow-hidden bg-gray-900 text-white">
      {/* retro starfield */}
      <div
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "radial-gradient(#ffffff 1px, transparent 1px), radial-gradient(#ffffff 1px, transparent 1px)",
          backgroundPosition: "0 0, 25px 25px",
          backgroundSize: "50px 50px",
          animation: "pulse 4s ease-in-out infinite",
        }}
      />
      {/* scanlines */}
      <div
        className="pointer-events-none absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,.06) 1px, transparent 1px)",
          backgroundSize: "100% 3px",
        }}
      />

      <div className="relative z-10 mx-auto flex min-h-screen max-w-3xl flex-col items-center justify-center px-6 text-center">
        <h1 className="text-shadow mb-4 font-['Silkscreen'] text-5xl md:text-7xl">
          Spellgather
        </h1>

        <div className="rank-plaque rank-plaque--grandmaster mt-2">
          <span className="rank-plaque__text">
            Where your Spellgather-ing Begins
          </span>
        </div>

        <p className="mt-6 max-w-xl text-gray-200">
          A hub for trading, playing, and discovering Magic cards with players
          nearby.
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            type="button"
            onClick={handleEnter}
            className="btn-pixel btn-pixel-primary"
          >
            Enter the Realm
          </button>

          <a
            href="#lore"
            className="btn-pixel btn-pixel-secondary"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById("lore");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Lore
          </a>
        </div>

        <div id="lore" className="mt-16 max-w-2xl text-sm text-gray-300">
          Curate your collection, set trade/play availability, and connect with
          locals. Pixel buttons. CRT vibes.
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: .25 }
          50% { transform: scale(1.02); opacity: .35 }
          100% { transform: scale(1); opacity: .25 }
        }
      `}</style>
    </div>
  );
}

